class Configuration {
    private readonly defaultServerUrl = "https://api.au.spiffcommerce.com";
    private readonly defaultServicesApiUrl = "https://services.au.spiffcommerce.com";
    private readonly defaultHubUrl = "https://hub.au.spiffcommerce.com";

    private serverUrl: string;
    private servicesApiUrl: string;
    private hubUrl: string;

    private serverUrlCallbacks: (() => void)[];

    constructor() {
        this.serverUrl = this.defaultServerUrl;
        this.servicesApiUrl = this.defaultServicesApiUrl;
        this.hubUrl = this.defaultHubUrl;
        this.serverUrlCallbacks = [];
    }

    getServerUrl() {
        return this.serverUrl;
    }

    getServicesApiUrl() {
        return this.servicesApiUrl;
    }

    getHubUrl() {
        return this.hubUrl;
    }

    setServerUrl(serverUrl: string) {
        this.serverUrl = serverUrl;
        this.serverUrlCallbacks.forEach((callback) => callback());
    }

    setServicesApiUrl(servicesApiUrl: string) {
        this.servicesApiUrl = servicesApiUrl;
    }

    setHubUrl(hubUrl: string) {
        this.hubUrl = hubUrl;
    }

    addServerUrlCallback(callback: () => void) {
        this.serverUrlCallbacks.push(callback);
    }
}

export const spiffCoreConfiguration = new Configuration();
